import {ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {DataConfig} from '../../../models/tabs-data';
import { Subscription} from 'rxjs';
import {select, Store} from '@ngrx/store';
import * as fromShared from '../../../reducers';
import {FormGroup, Validators} from '@angular/forms';
import {Config, GroupConfigs} from '../../../models/config';
import * as _ from 'lodash';
import {UpdatePlayerConfigurationAction, UpdatePlayerConfigurationClientAction} from '../../../actions/player-configuration-update';
import {InputTypes, PlayerConfigurationDefinition} from '../../../models/player-config-list-option';
import {IsUsedPlayerConfigurationDefinitionAction} from '../../../actions/player-configuration-definition';
import {IP_PATTERN, NUMERIC_PATTERN, TIME_PATTERN} from '../../../consts';
import {PlayerConfigurationService} from '../../../services/player-configuration.service';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'storever-edit-options',
  templateUrl: './edit-options.component.html',
  styleUrls: ['./edit-options.component.scss'],
})
export class EditOptionsComponent  implements OnInit, OnDestroy , OnChanges {

  @Input() dataConfig: DataConfig;
  @Input() form: FormGroup;
  @Input() itemUpdate: PlayerConfigurationDefinition;
  @Output() saveForm = new EventEmitter<Object>();
  private sub$: Subscription;
  private subscriptions = [];
  config: GroupConfigs;
  get isDetail(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path === 'detail/:id'
  }
  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private playerConfigurationService: PlayerConfigurationService,
              private cdr: ChangeDetectorRef ,
              private activatedRoute: ActivatedRoute,
              private store: Store<fromShared.AppState>) {
  }

  ngOnInit(): void {
    this.removeItemRemoveFormValidator();
  }


  ngOnDestroy(): void {
    this.dataConfig.form.markAsPristine();
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (_.has(changes, 'itemUpdate')) {
      const change = _.get(changes, 'itemUpdate');
      if (change.currentValue) {
        this.addOption(change.currentValue);
      }
    }

  }

  /**
   * - Value from FormGroup
   * - Update/patch part of the object
   * @param apiNames
   */
  save(apiNames: string[]): void {
    const resp = this.dataConfig.form.value;
    this.updateFormArray(resp)
    if (this.isDetail) {
      this.store.dispatch(new UpdatePlayerConfigurationAction({
        form: _.cloneDeep(resp),
        config: _.cloneDeep(this.dataConfig.groupConfigs.groupConfigs[0].config) }));

    } else {
      this.store.dispatch(new UpdatePlayerConfigurationClientAction({
        form: _.cloneDeep(resp),
        config: _.cloneDeep(this.dataConfig.groupConfigs.groupConfigs[0].config) }));

    }
    this.dataConfig.form.markAsPristine();
  }

  updateFormArray(resp: FormGroup): void {
    if (this.form) {
      for (const prop in resp) {
        if (this.dataConfig.groupConfigs.groupConfigs[0].config[this.findIndexByName(prop)].options.hideAll !== 'hide') {
          this.form[prop] = resp[prop];
        } else {
          this.form[prop] = null;
        }
      }
    } else {
      this.form = resp;
    }
  }

  undo(formPath: string[]): void {
    this.dataConfig.form.reset();
    this.dataConfig.form.enable({ emitEvent: true });
    this.dataConfigContentPatchForm();
  }

  dataConfigContentPatchForm(): void {
    if (this.form) {
      this.dataConfig.form.patchValue(this.form);
    }
    this.removeAddItemForm();
  }

  /**
   * cette fonction supprimer les options qui on etais ajouter par l'utilisateur du formulaire
   *
   */
  removeAddItemForm(): void {
    // tslint:disable-next-line:forin
    for (const prop in this.dataConfig.form.getRawValue()) {
      const value = this.dataConfig.form.controls[prop].value;
      if (typeof(value) === 'undefined' || value === null) {
        this.dataConfig.form.removeControl(prop);
        this.removeItemFromConfig(prop);
        this.store.dispatch(new IsUsedPlayerConfigurationDefinitionAction({name: prop, value: false}));
      } else {
        this.dataConfig.groupConfigs.groupConfigs[0].config[this.findIndexByName(prop)].options.hideAll = 'show';
      }
    }
  }
  /**
   * cette fonction supprimer validateur d'une option supprimer
   *
   */
  removeItemRemoveFormValidator(): void {
    this.sub$ = this.store.pipe(select(fromShared.selectors.getPlayerConfigDef)).subscribe( data => {
        if (data.length > 0) {
          data.forEach((def: PlayerConfigurationDefinition) => {
            if (def.isUsed === false && this.dataConfig.form.controls[def.name]) {
              if (this.dataConfig.groupConfigs.groupConfigs[0].config[this.findIndex(def)].options.hideAll === 'hide') {
                 this.dataConfig.form.controls[def.name].clearValidators();
                 this.dataConfig.form.controls[def.name].updateValueAndValidity();
                 this.dataConfig.form.markAsDirty();
                }
            }
          })
        }
      }
    );
    this.subscriptions.push(this.sub$);
  }
  /**
   * cette fonction supprimer les options qui on etais ajouter par l'utilisateur de la config
   *
   */
  removeItemFromConfig (label: string): void {
    // tslint:disable-next-line:typedef
    _.remove(this.dataConfig.groupConfigs.groupConfigs[0].config, function ( configItem: Config) {
          return configItem.controlName[0] === label;
        });
  }

  findIndex(item: PlayerConfigurationDefinition): number {
    return _.findIndex(this.dataConfig.groupConfigs.groupConfigs[0].config,  function(configItem: Config): boolean {
      return configItem.controlName[0] === item.name;
    });
  }
  findIndexByName(item: string): number {
    return _.findIndex(this.dataConfig.groupConfigs.groupConfigs[0].config,  function(configItem: Config): boolean {
      return configItem.controlName[0] === item;
    });
  }

  updateValidatorForm(def: PlayerConfigurationDefinition): void {
    if (InputTypes[def.inputType] === 'number') {
      this.dataConfig.form.controls[def.name].setValidators([Validators.required, Validators.pattern(NUMERIC_PATTERN)])
    } else if (def.inputConstraint === 1) {
      this.dataConfig.form.controls[def.name].setValidators(
        [Validators.required, Validators.min(def.inputConstraintParam1) , Validators.max(def.inputConstraintParam2)]);
    } else if (def.inputConstraint === 3) {
      this.dataConfig.form.controls[def.name].setValidators([Validators.required, Validators.pattern(IP_PATTERN)]);
    } else if (InputTypes[def.inputType] === 'time') {
      this.dataConfig.form.controls[def.name].setValidators([Validators.required, Validators.pattern(TIME_PATTERN)]);
    } else {
      this.dataConfig.form.controls[def.name].setValidators(Validators.required);
    }
  }

  addOption(item: PlayerConfigurationDefinition): void {
    if (this.findIndex(item) !== -1) {
      this.dataConfig.groupConfigs.groupConfigs[0].config[this.findIndex(item)].options.hideAll = 'show';
      this.updateValidatorForm(item);
      this.store.dispatch(new IsUsedPlayerConfigurationDefinitionAction({name: item.name, value: true}));
    } else {
      this.dataConfig.groupConfigs.groupConfigs[0].config = this.playerConfigurationService.creationOfConfig(
      this.dataConfig.groupConfigs.groupConfigs[0].config , item , null );
      this.dataConfig.form =  this.playerConfigurationService.addControl(this.dataConfig.form  , item , item.defaultValue);
      this.cdr.detectChanges();
    }
    this.dataConfig.form.markAsDirty();

  }
}
